// Removes Emergent platform branding badges via JS (CSS fallback in index.css)
export function hideEmergentBadge() {
  const sweep = () => {
    // Match anchors, divs, iframes that look like the Emergent badge.
    const selectors = [
      "#emergent-badge",
      "[id*='emergent-badge']",
      "[class*='emergent-badge']",
      "a[href*='emergent.sh']",
      "a[href*='app.emergent']",
      "iframe[src*='emergent.sh']",
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.style.display = "none";
        el.remove();
      });
    });
    // Text-based sweep: any fixed/anchored element containing "Made with Emergent"
    document.querySelectorAll("a, div").forEach((el) => {
      const t = (el.textContent || "").trim().toLowerCase();
      if (t === "made with emergent" || t.endsWith("made with emergent")) {
        const fixed = el.closest("[style*='position: fixed'], [style*='position:fixed']");
        (fixed || el).remove();
      }
    });
  };
  sweep();
  const obs = new MutationObserver(sweep);
  obs.observe(document.body, { childList: true, subtree: true });
  // Also run periodically for the first 10 seconds (some badges inject late)
  let count = 0;
  const interval = setInterval(() => {
    sweep();
    if (++count > 20) clearInterval(interval);
  }, 500);
}
